import React, { useState } from 'react';
import { LandingPage } from './pages/LandingPage';
import { DemoView } from './pages/DemoView';
export function App() {
  const [view, setView] = useState<'landing' | 'demo'>('landing');
  const [currentScreen, setCurrentScreen] = useState<number>(1);
  const handleLaunchDemo = () => {
    setView('demo');
    setCurrentScreen(1);
  };
  const handleBackToOverview = () => {
    setView('landing');
  };
  return <div className="min-h-screen bg-slate-50 font-sans text-slate-900 selection:bg-datmont-blue selection:text-white" data-id="element-0">
      {view === 'landing' ? <LandingPage onLaunchDemo={handleLaunchDemo} data-id="element-1" /> : <DemoView currentScreen={currentScreen} onNavigate={setCurrentScreen} onBack={handleBackToOverview} data-id="element-2" />}
    </div>;
}